import { Environment } from './env.type';

export const environment: Environment = {
  production: true,
  baseUrl: 'https://api.app.expowizard.com',
  userPoolId: 'us-east-1_4VeRun1RQ',
  userPoolClientId: '3par5unjl3mm4bacic7o8dmbe',
  appStoreUrl: 'https://apps.apple.com',
  playStoreUrl: 'https://play.google.com/store/apps/details',
  wsUrl: 'wss://fllbaoxo3d.execute-api.us-east-1.amazonaws.com/prod',
  domain: 'expo-wizard.auth.us-east-1.amazoncognito.com',
  stripe: {
    tableId: 'prctbl_1QgEBNF5bSvjHVTVA5C0c4cm',
    tableKey:
      'pk_live_51QIFonF5bSvjHVTVOaTmsLeNfmAqsrxhyAFLbRdYxsrDGdNPfSNmPzLxpXsuwS7xr6XPnLyH2l2Rm01u7G3FxfuU00rWeQbCTe',
    customerPortal: 'https://billing.stripe.com/p/login/5kAg2i5VvfN2dVebII',
  },
  // Security configuration for production environment
  security: {
    csrfCookieName: 'XSRF-TOKEN',
    // Strict CSP is always enabled in production (controlled by SecurityService)
    allowedDomains: [
      'api.app.expowizard.com',
      'app.expowizard.com',
      'js.stripe.com',
      'fonts.googleapis.com',
      'fonts.gstatic.com',
    ],
    tokenRefresh: {
      refreshBeforeExpiryMinutes: 5,
    },
  },
};
